export default __webpack_public_path__ + "static/media/activity.eeb8a44e.png";